import React, { useContext, useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Alert,
  Button,
  Col,
  Container,
  Form,
  Row,
  Spinner,
  Table,
  Card,
} from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import { GlobalContext } from "../Context/GlobalState";
import { useNavigate } from "react-router-dom";
import key1 from "../Images/key1.svg";
import pay from "../Images/pay.png";
import key2 from "../Images/key2.svg";
import key3 from "../Images/key3.svg";
import key4 from "../Images/key4.svg";
import key5 from "../Images/key5.svg";
import key6 from "../Images/cardimg5.svg";
import core1 from "../Images/core1.png";
import core2 from "../Images/core2.png";
import core3 from "../Images/core3.png";
import core4 from "../Images/core4.png";
import core5 from "../Images/core5.png";
import core6 from "../Images/core6.png";
import { MdContentPaste } from "react-icons/md";
import SideTab from "./Toolstab";
import TestimonialPage from "./Testonomialraghar";
import { FaArrowRight } from "react-icons/fa";
import { basicauth } from "../Utils/Credentials";
import { Helmet } from "react-helmet";
const Contentgenerator = () => {
  const resultRef = useRef(null);

  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);
  const [content, setContent] = useState("");
  const [generatedText, setGeneratedText] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [displayedText, setDisplayedText] = useState("");
  const [animationIndex, setAnimationIndex] = useState(0);
  const handleAnalyze = async () => {
    setError(null);
    setLoading(true);
    setGeneratedText("");

    if (!content.trim()) {
      setError("Please paste some content before analyzing.");

      setLoading(false);
      return;
    }

    try {
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Seo/GetGenerativeTexts`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            meta_name: "Title",
            relational_text: `Please generate content on topic ${content}`,
            type: "1",
          }),
        }
      );

      const data = await response.json();
      const text = data?.candidates?.[0]?.content?.parts?.[0]?.text;
      if (text) {
        setGeneratedText(text);
        setDisplayedText("");
        setAnimationIndex(0);
        setTimeout(() => {
          resultRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 200);
      } else {
        setError("Failed to generate content.");
      }
    } catch (err) {
      console.error("API Error:", err);
      setError("An error occurred while generating the content.");
    }

    setLoading(false);
  };
  useEffect(() => {
    if (!generatedText) return;

    const words = generatedText.split(" ");
    if (animationIndex < words.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(words.slice(0, animationIndex + 1).join(" "));
        setAnimationIndex((prev) => prev + 1);
      }, 80);

      return () => clearTimeout(timeout);
    }
  }, [animationIndex, generatedText]);
  const renderFormattedText = (text) => {
    const lines = text.split("\n");
    return lines.map((line, index) => {
      if (line.startsWith("## ")) {
        return (
          <h4 key={index} style={{ fontWeight: "bold", marginTop: "1rem" }}>
            {line.replace("## ", "")}
          </h4>
        );
      } else if (line.startsWith("**") && line.endsWith("**")) {
        return (
          <p key={index} style={{ fontWeight: "bold" }}>
            {line.replace(/\*\*/g, "")}
          </p>
        );
      } else if (line.trim().startsWith("* ")) {
        return (
          <ul key={index} style={{ paddingLeft: "1.2rem" }}>
            <li>{line.replace("* ", "")}</li>
          </ul>
        );
      } else {
        return <p key={index}>{line}</p>;
      }
    });
  };
  const jsonLdData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Bix AI Content Generator | Write Smarter, Rank Faster",
    url: "https://seobix.com/bix-content-generator",
    description:
      "Boost your content strategy with Bix Content Generator — the AI tool that creates SEO-optimized blogs, posts, and articles in seconds. Try it now!",
    publisher: {
      "@type": "Organization",
      name: "Seobix",
      url: "https://seobix.com",
      logo: {
        "@type": "ImageObject",
        url: "https://seobix.com/Images/Backlinks.png",
      },
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Bix Content Generator",
          item: "https://seobix.com/bix-content-generator",
        },
      ],
    },
    mainEntity: {
      "@type": "SoftwareApplication",
      name: "Bix AI Content Generator",
      applicationCategory: "SEO Tool",
      operatingSystem: "Web",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
        category: "Free SEO Tool",
      },
    },
    inLanguage: "en",
    keywords: [
      "ai text generator",
      "ai blog writer",
      "ai content writer",
      "ai writing tool",
      "ai social media post generator",
      "ugc content creator",
      "text ai generator",
      "best ai text generator",
      "content creation ai",
      "ai to write articles",
      "content writing ai",
      "user generated content marketing",
      "user generated content seo",
      "user generated content strategy",
      "user generated content websites",
    ],
    mainEntityOfPage: [
      {
        "@type": "Question",
        name: "What is Bix AI Content Generator?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Bix AI Content Generator is a tool that creates SEO-optimized blogs, articles, and social media posts instantly, helping improve your content strategy.",
        },
      },
      {
        "@type": "Question",
        name: "Can Bix AI Content Generator improve SEO?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, by creating high-quality, optimized content quickly, Bix helps increase search engine visibility and improve rankings.",
        },
      },
      {
        "@type": "Question",
        name: "Is Bix Content Generator free to use?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, Bix Content Generator is free to use, allowing you to generate AI-based content without any cost.",
        },
      },
    ],
  };

  return (
    <Container fluid className="p-0" style={{ overflowX: "clip" }}>
      <div>
        <Helmet>
          <title>Bix AI Content Generator | Write Smarter, Rank Faster</title>
          <meta
            name="description"
            content="Boost your content strategy with Bix Content Generator — the AI tool that creates SEO-optimized blogs, posts, and articles in seconds. Try it now!"
          />
          <meta
            name="keywords"
            content="ai text generator, ai blog writer, ai content writer, ai writing tool, ai social media post generator, ugc content creator, text ai generator, best ai text generator, content creation ai, ai to write articles, content writing ai, user generated content marketing, user generated content seo, user generated content strategy, user generated content websites"
          />
          <link
            rel="canonical"
            href="https://seobix.com/bix-content-generator"
          />

          <meta
            property="og:title"
            content="Bix AI Content Generator | Write Smarter, Rank Faster"
          />
          <meta
            property="og:description"
            content="Boost your content strategy with Bix Content Generator — the AI tool that creates SEO-optimized blogs, posts, and articles in seconds. Try it now!"
          />
          <meta
            property="og:url"
            content="https://seobix.com/bix-content-generator"
          />
          <meta property="og:site_name" content="Seobix" />
          <meta property="og:type" content="website" />
          <meta
            property="og:image"
            content="https://seobix.com/Images/Backlinks.png"
          />
          <meta property="og:image:width" content="600" />
          <meta property="og:image:height" content="600" />
          <meta property="og:locale" content="en_US" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content="Bix AI Content Generator | Write Smarter, Rank Faster"
          />
          <meta
            name="twitter:description"
            content="Boost your content strategy with Bix Content Generator — the AI tool that creates SEO-optimized blogs, posts, and articles in seconds. Try it now!"
          />
          <meta
            name="twitter:image"
            content="https://seobix.com/Images/Backlinks.png"
          />
          <meta name="twitter:site" content="@seobix" />
          <meta name="twitter:creator" content="@seobix" />

          <script type="application/ld+json">
            {JSON.stringify(jsonLdData)}
          </script>
        </Helmet>

        <Nav />
      </div>
      <Row className="d-flex justify-content-center mb-5">
        <Col md={10} className="mt-4">
          <h1 className="mb-3 text-center">
            <b>Bix Content Generator</b>
          </h1>
          <Form>
            <Form.Group
              className="mb-3"
              controlId="contentTextarea"
              style={{ position: "relative" }}
            >
              <MdContentPaste
                style={{
                  position: "absolute",
                  top: "18px",
                  left: "20px",
                  fontSize: "1.5rem",
                  color: "#ccc",
                  pointerEvents: "none",
                  zIndex: "1",
                }}
              />
              <Form.Control
                as="textarea"
                rows={15}
                placeholder="Enter your topic here..."
                value={content}
                onChange={(e) => setContent(e.target.value)}
                style={{
                  fontSize: "1rem",
                  padding: "1.25rem 1.25rem 1.25rem 3rem",
                  border: "1px solid #ccc",
                  borderRadius: "12px",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
                  transition: "box-shadow 0.3s ease-in-out",
                  resize: "vertical",
                }}
              />
            </Form.Group>

            <Button
              variant="primary"
              onClick={handleAnalyze}
              disabled={loading}
            >
              {loading ? <Spinner animation="border" size="sm" /> : "Generate"}
            </Button>
          </Form>

          {error && (
            <Alert variant="danger" className="mt-3">
              {error}
            </Alert>
          )}
          {generatedText && (
            <div
              ref={resultRef}
              className="mt-4 p-4 rounded"
              style={{ backgroundColor: "#f8f9fa", border: "1px solid #ccc" }}
            >
              <p style={{ whiteSpace: "pre-wrap" }}>
                {renderFormattedText(displayedText)}
              </p>
            </div>
          )}
          <Row className="justify-content-between">
            <Col md={8}>
              <Content />
            </Col>

            <Col md={3}>
              <div
                className="mb-5"
                style={{
                  position: "sticky",
                  top: "20px",
                  zIndex: 10,
                  background: "#f8f9fa",
                  padding: "1rem",
                  borderRadius: "10px",
                }}
              >
                <h5
                  className="text-center mb-4"
                  style={{
                    fontWeight: "bold",
                    fontSize: "1.3rem",
                    color: "#fff",
                    backgroundColor: "#799EFF",
                    display: "inline-block",
                    padding: "6px 16px",
                    borderRadius: "0.5rem",
                  }}
                >
                  🚀 Explore More SEO Tools
                </h5>
                <SideTab />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background:
            "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",

          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};

const Content = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className="">
      <h2 className=" mt-md-4">
        Free Bix Content Generator to Create High-Quality Content
      </h2>

      <p className=" mt-2">
        Some content just cannot be qualified as good content, and Google knows
        that.The SeoBix Content Quality Checker will refine or generate new
        content for you, ensuring that the content remains clear, optimized, and
        friendly to its users. It is not an everyday grammar checker; instead,
        it checks to make sure your blog, article, or web-based content is
        readable, SEO-friendly, and user-friendly.
      </p>
      <p className=" mt-2">
        That’s where a free DA PA checker or website authority analyzer comes
        in. It allows you to evaluate your domain’s authority, understand its
        SEO credibility, and pinpoint opportunities to boost its performance..
        Whether you’re running one site or managing client portfolios, this free
        DA PA checker gives you a clear picture of your website authority using
        a simple domain SEO check.
      </p>

      <div style={{ position: "relative" }}>
        <p>
          But here’s the best part: SeoBix isn’t just checking your content.
          It’s also helping you create it.
        </p>

        {!showMore && (
          <div
            style={{
              position: "absolute",
              bottom: "0.5rem",
              left: 0,
              right: 0,
              height: "2.5em",
              background:
                "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 100%)",
            }}
          />
        )}
      </div>
      <div className="d-flex justify-content-center">
        {!showMore && (
          <Button
            onClick={() => setShowMore(true)}
            style={{
              padding: "6px 20px",
              backgroundColor: "#fff",
              color: "#0d6efd",
              fontWeight: "600",
              fontSize: "0.95rem",
              border: "2px solid #0d6efd",
              borderRadius: "999px",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#0d6efd";
              e.target.style.color = "#fff";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#fff";
              e.target.style.color = "#0d6efd";
            }}
          >
            Read More
          </Button>
        )}
      </div>

      {showMore && (
        <>
          <h3>What Makes This the Best Bix Content Generator Tool?</h3>

          <p>
            Yes, with our free Bix content generator, you can go from idea to
            polished article in minutes.
          </p>
          <p>
            Most content tools either check your text or generate
            robotic-sounding paragraphs. SeoBix does both better.
          </p>

          <p>
            <strong>Here’s what makes SeoBix stand out:</strong>
          </p>
          <ul>
            <li>
              <strong>Smart Quality Check:</strong> Find out if your content is
              clear, easy to read.
            </li>
            <li>
              <strong>SEO-Optimized Suggestions:</strong> Improve your keywords,
              sentence structure, and content flow.
            </li>
            <li>
              <strong>Human-Like Results:</strong> Our generator doesn’t sound
              like a bot from the future. It writes like a real person.
            </li>
            <li>
              <strong>Instant Feedback:</strong> Just paste your content and get
              instant results. No sign-up. No limits.
            </li>
          </ul>

          <h3>From Idea to Execution with Our Bix Content Generator</h3>
          <p>
            Stuck on changing your idea to words? SeoBix’s content generator can
            help you—it changes your idea into words. You can turn a keyword or
            phrase into a structured, readable blog within seconds.
          </p>
          <p>
            Need a starting point? Use our content idea generator to brainstorm
            headlines and topics that matter to your audience.
          </p>

          <h3>Article Generator Online — Built for Real Writers</h3>
          <p>
            Most article generator online tools just dump a bunch of
            keyword-stuffed nonsense onto the page. SeoBix takes a smarter
            route. It understands your niche, keeps your tone natural, and
            respects your reader’s attention.
          </p>
          <p>
            Whether you’re writing for a niche blog or running a full-on content
            marketing campaign, SeoBix helps you:
          </p>
          <ul>
            <li>Create quality content faster</li>
            <li>Check your tone, readability, and structure</li>
            <li>Improve keyword usage without overdoing it</li>
          </ul>

          <h3>A Free Bix Content Generator</h3>
          <p>
            You want something powerful, but free. SeoBix offers a full-powered
            free Bix content generator that doesn’t ask for your card details or
            force you to upgrade after two uses.
          </p>
          <p>You can:</p>
          <ul>
            <li>Generate blog posts, intros, and outlines instantly</li>
            <li>Analyze your existing content for quality issues</li>
            <li>
              Get suggestions to make your writing sharper and more SEO-friendly
            </li>
          </ul>
          <p>
            It’s fast, accurate, and doesn’t feel like a free tool, because it
            was built to compete with the best.
          </p>

          <h3>Why Choose SeoBix as Your Bix content generator?</h3>
          <p>Most AI tools write. A few check. SeoBix does both better.</p>
          <p>
            Use SeoBix as your go-to Bix content generator and quality checker,
            all in one. Whether you’re creating content from scratch or checking
            what you already wrote, this tool helps you sound like a pro while
            keeping SEO in check.
          </p>

          <h4>Start for Free—No Signup Needed</h4>
          <p>
            You don’t need a login. You don’t need a subscription. Just paste an
            idea and click analyze. Use our free Bix content generator to start
            fresh. Need ideas? Our content idea generator has you covered.
          </p>
          <p>
            SeoBix isn’t just another tool—it’s your full-stack solution for
            quality content.
          </p>

          <h3>How to Use the SeoBix Content Quality Checker</h3>
          <p>
            You generate content from SeoBix’s Bix content generator. Now if you
            want to check the quality of the content or see if it is written by
            a human or AI, use the content analyzer or Humanizer. These features
            help you assess:
          </p>
          <ul>
            <li>Readability of the content</li>
            <li>Plagiarism of the content</li>
            <li>AI-generated words</li>
            <li>Word count</li>
          </ul>

          <p>Just open SeoBix and:</p>
          <ol>
            <li>Paste your content in the box.</li>
            <li>Click "Analyze."</li>
            <li>
              Get instant insights—readability score, keyword density, sentence
              length, and more.
            </li>
            <li>
              Edit your content directly or use the Bix content generator to
              rewrite.
            </li>
          </ol>
          <p>It’s that easy.</p>

          <h3>Frequently Asked Questions</h3>
          <ol>
            <li>
              <strong>What is the SeoBix Content Quality Checker?</strong>
              <br />
              The tool is simple to use: it checks your content for cleanliness,
              readability, and SEO readiness. Just paste your text to get
              instant feedback on grammar, structure, keyword usage, and tone.
            </li>
            <li>
              <strong>Can SeoBix create content too?</strong>
              <br />
              Yes. SeoBix is more than just a checker. It’s also a powerful Bix
              content generator. You can write blog posts, articles, product
              descriptions—anything—without sounding like a bot.
            </li>
            <li>
              <strong>Is this really free to use?</strong>
              <br />
              Totally free. No sign-up, no payment. Use the free content
              generator, check your writing, and even fix it on the spot. No
              hidden upgrades.
            </li>
            <li>
              <strong>Will my content pass AI detection tools?</strong>
              <br />
              Yes. SeoBix content sounds natural and imperfect—just like a real
              human wrote it. Whether editing or generating, it helps your text
              pass AI detection.
            </li>
            <li>
              <strong>
                How’s this better than other article generator tools?
              </strong>
              <br />
              Most generators spit out robotic or repetitive text. SeoBix keeps
              it real with human-like flow, keyword balance, and structured
              readability. It’s both a content quality checker and a smart blog
              post generator.
            </li>
          </ol>

          <div className="d-flex justify-content-center mt-4">
            <Button
              onClick={() => setShowMore(false)}
              style={{
                padding: "6px 20px",
                backgroundColor: "#fff",
                color: "#dc3545",
                fontWeight: "600",
                fontSize: "0.95rem",
                border: "2px solid #dc3545",
                borderRadius: "999px",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#dc3545";
                e.target.style.color = "#fff";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#fff";
                e.target.style.color = "#dc3545";
              }}
            >
              Hide
            </Button>
          </div>
        </>
      )}
      <Plancard />
      <Trialcards />
      <Related />
      <TestimonialPage />
      <Specialoffer />
      <BackLinkCards />
      <Plancard />
    </div>
  );
};
const Plancard = () => {
  const [isYearly, setIsYearly] = useState(false);
  const plans = [
    {
      title: "Free",
      monthly: "$0",
      yearly: "$0",
      Free: "3 Month Free Trial",
      features: ["Limited Access"],
      buttonText: "Buy Plan",
      color: "#e0f2fe",
      border: "#38bdf8",
      image: pay,
    },
    {
      title: "Basic",
      monthly: "$150/mo",
      features: ["5 Projects", "Standard Reports", "Email Support"],
      buttonText: "Buy Plan",
      color: "#e7f5ff",
      border: "#339af0",
      image: pay,
    },
    {
      title: "Standard",
      monthly: "$350/mo",
      features: ["10 Projects", "Advanced Reports", "Priority Support"],
      buttonText: "Buy Plan",
      color: "#e6fcf5",
      border: "#20c997",
      image: pay,
    },
    {
      title: "Premium",
      monthly: "$750/mo",
      features: ["Unlimited Projects", "All Features", "24/7 Support"],
      buttonText: "Buy Plan",
      color: "#fff3bf",
      border: "#fcc419",
      image: pay,
    },
  ];

  return (
    <Container className="my-5">
      <div className="text-center mb-4">
        <h2 style={{ fontWeight: "700", fontSize: "2rem" }}>
          Boost Your SEO With Our Amazing Plans
        </h2>
        <h4 className="font-weight-bold mb-4" style={{ color: "#441752" }}>
          🚀 Improve Your Rankings —{" "}
          <span style={{ color: "#FC4100" }}>
            Try Our Service Free for 3 Months!
          </span>
        </h4>
        <p style={{ color: "#6b7280" }}>
          Flexible pricing plans designed for every stage of your journey
        </p>
        <div className="d-flex justify-content-center mt-4">
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontWeight: "500" }}>Monthly</span>

            <div
              className="m-2"
              style={{ transform: "scale(1.5)", transformOrigin: "center" }}
            >
              <Form.Check
                type="switch"
                id="custom-switch"
                checked={isYearly}
                onChange={() => setIsYearly(!isYearly)}
              />
            </div>

            <div className="d-flex align-items-center gap-2">
              <span style={{ fontWeight: "500" }}>Yearly</span>

              <div
                className="start-now-btn mx-3"
                style={{
                  backgroundColor: "#e6f4ea",
                  color: "#2f855a",
                  padding: "6px 12px",
                  borderRadius: "8px solid",
                  fontWeight: "600",
                  fontSize: "0.9rem",
                  border: "1px solid #20c997",
                }}
              >
                🎉{" "}
                <span style={{ color: "#0B1D51" }}>
                  Get{" "}
                  <span style={{ color: "#0B1D51" }}>
                    <b>30% OFF</b>
                  </span>{" "}
                  on Yearly Plans
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Row className="g-4 justify-content-center">
        {plans.map((plan, idx) => (
          <Col md={6} lg={3} key={idx}>
            <div style={{ position: "relative" }}>
              {plan.title === "Free" && (
                <div
                  style={{
                    position: "absolute",
                    top: "-12px",
                    left: 0,
                    right: 0,
                    height: "32px",
                    backgroundColor: "#38bdf8",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    zIndex: 2,
                  }}
                >
                  {plan.Free}
                </div>
              )}

              <Card
                className="p-2"
                style={{
                  backgroundColor: plan.color,
                  border: `2px solid ${plan.border}`,
                  borderRadius: "16px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow:
                    plan.title === "Free"
                      ? "0 12px 28px rgba(56, 189, 248, 0.5)"
                      : "0 4px 12px rgba(0,0,0,0.05)",
                  marginTop: plan.title === "Free" ? "16px" : "0",
                }}
              >
                <Card.Body>
                  <Card.Title style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    {plan.title}
                  </Card.Title>
                  <h3 style={{ fontWeight: "bold", margin: "1rem 0" }}>
                    {isYearly
                      ? plan.title === "Free"
                        ? plan.yearly
                        : (() => {
                            const monthlyPrice = parseFloat(
                              plan.monthly.replace(/[^0-9.]/g, "")
                            );
                            const yearlyRaw = monthlyPrice * 12;
                            const discounted = yearlyRaw * 0.7;
                            return `$${Math.round(discounted)}/yr`;
                          })()
                      : plan.monthly}
                  </h3>
                  <a
                    href="/register"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      backgroundColor: plan.border,
                      color: "white",
                      textDecoration: "none",
                      borderRadius: "999px",
                      padding: "8px 20px",
                      fontWeight: "600",
                      marginTop: "1rem",
                    }}
                  >
                    {plan.buttonText}
                  </a>

                  <div className="mt-3">
                    <img
                      src={plan.image}
                      alt={plan.title}
                      style={{
                        // width: "15vw",
                        objectFit: "contain",
                        marginBottom: "1rem",
                      }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};
const Trialcards = () => {
  const cardsData = [
    {
      keyImg: key1,
      coreImg: core5,
      title: "Integrated Search Console, Google Trends and Google Analytics",
      desc: "Smarter SEO insights in one place and see what’s popular in different countries and other website matrics. Seobix makes it easy and effective.",
    },
    {
      keyImg: key2,
      coreImg: core4,
      title: "Search Engine Optimization",
      desc: "SEO gets easier with SeoBix whether you just start your website or growing your online presence. Our all-in-one SEO tool helps you fix issues and improve online visibility.",
    },
    {
      keyImg: key3,
      coreImg: core2,
      title: "Social Media Optimization",
      desc: "You can monitor and post from all your favorite platforms, YouTube, Facebook, LinkedIn, and Instagram, all from under one roof.",
    },
    {
      keyImg: key4,
      coreImg: core1,
      title: "Competitive Research Overview",
      desc: "You can check domain overview and website age and how their pages look on Google with our SERP Simulator. Seobix gives you the insights you need to compete smarter, not harder.",
    },
    {
      keyImg: key5,
      coreImg: core3,
      title: "Structure Data",
      desc: "With the right setup, At Seobix, we make it super easy to add and check structured data, so your site gets noticed for all the right reasons.",
    },
    {
      keyImg: key6,
      coreImg: core6,
      title: "Keyword Research",
      desc: "Our Bix keyword Research helps you discover high-potential keywords your audience is actually searching for.",
    },
  ];
  return (
    <div className="mt-md-5 mt-3 m-md-0 m-2 ">
      <h2
        className="text-center m-4"
        style={{ fontWeight: "700", fontSize: "2rem" }}
      >
        What Includes In All Plans ?
      </h2>
      <div className="row m-0 p-0">
        {cardsData.map((card, index) => (
          <div key={index} className="col-12 col-md-4 p-2 d-flex">
            <div className="card w-100 h-100 p-2">
              <div className="d-flex h-100">
                <div
                  style={{ flex: 1 }}
                  className="d-flex flex-column position-relative"
                >
                  <div>
                    <img
                      src={card.keyImg}
                      alt={card.title}
                      style={{
                        height: "5vh",
                        objectFit: "contain",
                        marginBottom: "0.5rem",
                      }}
                    />
                    <h5>{card.title}</h5>
                  </div>
                </div>

                <div
                  style={{ flex: 1 }}
                  className="d-flex align-items-center justify-content-center"
                >
                  <img
                    src={card.coreImg}
                    alt={card.title}
                    className="img-fluid"
                    style={{ maxHeight: "200px", objectFit: "contain" }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
const Specialoffer = () => {
  return (
    <div
      className="start-now-btn p-2"
      style={{
        background: "#799EFF",
        borderRadius: "24px",
        color: "white",
        textAlign: "center",
        margin: "3rem auto",
        width: "90%",
        maxWidth: "1000px",
        position: "relative",
      }}
    >
      <h2 className="mb-3" style={{ fontSize: "2rem", fontWeight: "bold" }}>
        Let’s do this! Start unlocking powerful backlink insights.
      </h2>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <a
          // href="/register"
          onClick={() => window.open("https://dashboard.seobix.com/", "_blank")}
          style={{
            backgroundColor: "#fff",
            color: "#000",
            padding: "12px 24px",
            borderRadius: "12px",
            fontWeight: "600",
            textDecoration: "none",
            minWidth: "150px",
            textAlign: "center",
          }}
        >
          Start 3 Months Free Trial
        </a>
      </div>

      <p style={{ color: "#fff", marginTop: "20px", fontSize: "14px" }}>
        <b> Full access — No Credit card Needed.</b>
      </p>
    </div>
  );
};
const Related = () => {
  const navigate = useNavigate();
  const resultRef = useRef(null);
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [readability, setReadability] = useState(null);
  const [seoKeywords, setSeoKeywords] = useState([]);
  const analyzeKeywordDensity = (text) => {
    const stopWords = new Set([
      "the",
      "is",
      "in",
      "and",
      "to",
      "a",
      "of",
      "for",
      "on",
      "with",
      "as",
      "by",
      "at",
      "an",
      "this",
      "that",
      "it",
    ]);
    const words = text
      .toLowerCase()
      .replace(/[^a-z\s]/g, "")
      .split(/\s+/)
      .filter((word) => word && !stopWords.has(word));
    const totalWords = words.length;
    const frequency = {};
    words.forEach((word) => {
      frequency[word] = (frequency[word] || 0) + 1;
    });
    const keywordData = Object.entries(frequency)
      .map(([word, count]) => ({
        word,
        count,
        density: ((count / totalWords) * 100).toFixed(2),
      }))
      .sort((a, b) => b.count - a.count)
      .slice(0, 10);
    return keywordData;
  };

  const calculateReadability = (text) => {
    const sentences = text.split(/[.?!]+/).filter(Boolean);
    const words = text.split(/\s+/).filter(Boolean);
    const wordCount = words.length;
    const sentenceCount = sentences.length || 1;
    const syllableCount = wordCount * 1.5;
    const fleschReadingEase =
      206.835 -
      1.015 * (wordCount / sentenceCount) -
      84.6 * (syllableCount / wordCount);

    return {
      fleschReadingEase: Math.max(0, Math.min(fleschReadingEase, 100)),
      sentenceCount,
    };
  };
  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);
  const handleAnalyze = async () => {
    setLoading(true);
    if (!content.trim()) {
      setError("Please paste some content before analyzing.");
      setResult(null);
      setReadability(null);
      return;
    }
    setError("");
    setResult(null);
    setReadability(null);

    try {
      const readabilityScore = calculateReadability(content);
      setReadability(readabilityScore);
      const keywords = analyzeKeywordDensity(content);
      setSeoKeywords(keywords);
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/ContentAnalysis/ContentChecker`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ text: content }),
        }
      );

      const data = await response.json();

      if (data.status === "success") {
        setResult(data.data);
        setTimeout(() => {
          resultRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 200);
      } else {
        setError("Failed to analyze content.");
      }
    } catch (err) {
      console.error("API Error:", err);
      setError("An error occurred while analyzing the content.");
    }
    setLoading(false);
  };

  const twoDecimalPlaces = (value) => {
    return Number(value).toFixed(2).toString();
  };
  const handleClick = () => {
    navigate("/content-quality-checker");
  };

  return (
    <div className="mt-5 mb-5">
      <div
        // onClick={handleClick}
        style={{
          cursor: "pointer",
        }}
      >
        <Row
          className="justify-content-center"
          style={{
            margin: "0",
            background:
              "linear-gradient(to right, #AFDDFF 0%, #C5E7FF 30%, #DAF0FF 60%, #EDF8FF 85%, #FFFFFF 100%)",
            borderRadius: "12px",
            transition: "transform 0.2s ease",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.01)")
          }
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <Col md={10} className="p-3">
            <h3 className="text-center">
              <b>Analyze Quality Of Your Content</b>
            </h3>
            <p className="text-center">
              Just paste your content — our tool instantly checks readability,
              structure, and SEO quality in seconds.
            </p>

            <Form>
              <Form.Group
                className="mb-3"
                controlId="contentTextarea"
                style={{ position: "relative" }}
              >
                <MdContentPaste
                  style={{
                    position: "absolute",
                    top: "18px",
                    left: "20px",
                    fontSize: "1.5rem",
                    color: "#ccc",
                    pointerEvents: "none",
                    zIndex: "1",
                  }}
                />
                <Form.Control
                  as="textarea"
                  rows={8}
                  placeholder="Paste your content here..."
                  value={content}
                  onChange={(e) => setContent(e.target.value)}
                  style={{
                    fontSize: "1rem",
                    padding: "1.25rem 1.25rem 1.25rem 3rem",
                    border: "1px solid #ccc",
                    borderRadius: "12px",
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
                    transition: "box-shadow 0.3s ease-in-out",
                    resize: "vertical",
                    minHeight: "250px",
                  }}
                />
              </Form.Group>
              <Button
                variant="primary"
                onClick={handleAnalyze}
                disabled={loading}
              >
                {loading ? <Spinner animation="border" size="sm" /> : "Analyze"}
              </Button>
            </Form>

            {error && (
              <Alert variant="danger" className="mt-3">
                {error}
              </Alert>
            )}

            {(result || readability) && (
              <div className="mt-3 mb-3" ref={resultRef}>
                <h5 className="mb-2 text-center">Analysis Summary</h5>
                <Row className="g-4 mt-2 p-0">
                  <Col md={6}>
                    {result && (
                      <>
                        <Row className="g-2 p-0">
                          <Col className="px-1" md={6}>
                            <GaugeCard
                              title="AI Words"
                              value={result.aiWords}
                              max={result.textWords || 1000}
                              color="#0d6efd"
                            />
                          </Col>
                          <Col className="px-1" md={6}>
                            <GaugeCard
                              title="Plagiarism %"
                              value={result.fakePercentage}
                              max={100}
                              color="#dc3545"
                            />
                          </Col>
                        </Row>
                        <Row className="g-2 mt-1 p-0">
                          <Col className="px-1" md={6}>
                            <GaugeCard
                              title="Human %"
                              value={result.isHuman}
                              max={100}
                              color="#198754"
                            />
                          </Col>
                          <Col className="px-1" md={6}>
                            <GaugeCard
                              title="Word Count"
                              value={result.textWords}
                              max={2000}
                              color="#6f42c1"
                            />
                          </Col>
                        </Row>
                      </>
                    )}

                    {result && readability && (
                      <>
                        <Row className="g-2 mt-1 p-0">
                          <Col
                            className="px-1"
                            md={6}
                            style={{
                              filter: "blur(3px)",
                              pointerEvents: "none",
                            }}
                          >
                            <GaugeCard
                              title="Readability"
                              value={twoDecimalPlaces(
                                readability.fleschReadingEase
                              )}
                              max={100}
                              color="#17a2b8"
                            />
                          </Col>
                          <Col
                            className="px-1"
                            md={6}
                            style={{
                              filter: "blur(3px)",
                              pointerEvents: "none",
                            }}
                          >
                            <GaugeCard
                              title="Sentences"
                              value={readability.sentenceCount}
                              max={100}
                              color="#fd7e14"
                            />
                          </Col>
                        </Row>
                      </>
                    )}
                  </Col>

                  <Col md={6} className="d-flex justify-content-center">
                    {result && seoKeywords.length > 0 && (
                      <div
                        className="p-3 border rounded bg-light"
                        style={{
                          // height: "70vh",
                          overflow: "auto",
                          scrollbarWidth: "none",
                        }}
                      >
                        <h6 className="mb-3 text-center">
                          🔍 SEO Keyword Density (Top 5)
                        </h6>
                        <p className="text-muted small text-center mb-2">
                          Showing most-used keywords excluding common words.
                        </p>

                        <table
                          className="table table-sm table-bordered mb-0"
                          style={{ fontSize: "0.95rem" }}
                        >
                          <thead className="table-light">
                            <tr>
                              <th>Keyword</th>
                              <th>Occurrences</th>
                              <th>Density (%)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {seoKeywords.slice(0, 7).map((item, idx) => (
                              <tr
                                key={idx}
                                style={
                                  idx >= 5
                                    ? {
                                        filter: "blur(3px)",
                                        pointerEvents: "none",
                                      }
                                    : {}
                                }
                              >
                                <td>
                                  <b>{item.word}</b>
                                </td>
                                <td>{item.count}</td>
                                <td>{item.density}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </Col>
                </Row>
                <h6 className="text-end m-4" onClick={handleClick}>
                  Click to get Complete Report <FaArrowRight />
                </h6>
              </div>
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
};
const cardData = [
  {
    title: "Content Quality Checker",
    description:
      "Instantly check your content for grammar, readability, keyword usage, and SEO structure. Get clear, actionable feedback to improve your writing in seconds.",
    linkText: "Check Content Quality",
    linkUrl: "/content-quality-checker",
    bgColor: "#f4f7fb",
  },
  {
    title: "Humanizer Tool",
    description:
      "Convert robotic AI-generated text into human-like, natural writing. Bypass AI detectors and make your content feel more authentic.",
    linkText: "Use Humanizer",
    linkUrl: "/ai-humanizer-tool",
    bgColor: "#dff5ff",
  },
  {
    title: "Bix content generator",
    description:
      "Generate high-quality blog posts, product descriptions, intros, and more from a single keyword. Smart, fast, and human-sounding.",
    linkText: "Start Generating",
    linkUrl: "/bix-content-generator",
    bgColor: "#f4f7fb",
  },
  {
    title: "DA/PA Checker",
    description:
      "Evaluate domain authority and page authority instantly. Understand your SEO strength and compare with competitors in real-time.",
    linkText: "Check DA/PA",
    linkUrl: "/da-pa-checker",
    bgColor: "#d6ffd6",
  },
];

const BackLinkCards = () => {
  return (
    <div style={{ overflow: "hidden", padding: "20px" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">
            Content Optimization Toolkit: Everything You Need
          </h2>
        </div>
        <div className="row justify-content-center g-4">
          {cardData.map((card, index) => (
            <div key={index} className="col-md-6 col-lg-3 p-1">
              <div
                style={{
                  backgroundColor: card.bgColor,
                  padding: "24px",
                  borderRadius: "20px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <h5 className="fw-bold">{card.title}</h5>
                  <p className="text-muted" style={{ fontSize: "15px" }}>
                    {card.description}
                  </p>
                </div>
                <div>
                  <a
                    href={card.linkUrl}
                    className="text-primary fw-semibold"
                    style={{ textDecoration: "none" }}
                  >
                    {card.linkText} →
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
const GaugeCard = ({ title, value, max, color }) => {
  const percentage = Math.min((value / max) * 100, 100);
  const radius = 60;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <div
      className="p-2 bg-white rounded border text-center"
      style={{
        boxShadow:
          "0 4px 8px rgba(0, 0, 0, 0.15), 0 6px 20px rgba(0, 0, 0, 0.1)",
        width: 200,
        margin: "auto",
      }}
    >
      <h6 className="m-0 mb-2">{title}</h6>

      <div
        style={{
          position: "relative",
          width: "100%",
          height: 100,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <svg width="140" height="80">
          <circle
            cx="70"
            cy="70"
            r={radius}
            fill="transparent"
            stroke="#eee"
            strokeWidth="12"
            strokeDasharray={circumference}
            strokeDashoffset={0}
            transform="rotate(-90 70 70)"
          />
          <circle
            cx="70"
            cy="70"
            r={radius}
            fill="transparent"
            stroke={color}
            strokeWidth="12"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            transform="rotate(-90 70 70)"
          />
        </svg>

        <div
          style={{
            position: "absolute",
            top: "60%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            fontSize: "1.4rem",
            fontWeight: "bold",
            color: "#000",
          }}
        >
          {value}
        </div>
      </div>
    </div>
  );
};
export default Contentgenerator;
